var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{'pressable': _vm.linkToCustomer},style:({
    width: _vm.size + 'px',
    height: _vm.size + 'px',
    borderRadius: _vm.size + 'px'
  }),attrs:{"src":_vm.avatarUri,"alt":""},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }